import { Component, OnInit, OnDestroy, ViewChild, EventEmitter, Input, Output, ViewEncapsulation, ElementRef } from '@angular/core';
import { SignaturePadComponent } from '../signature-pad/signature-pad.component';

@Component({
  selector: 'app-signature-section',
  templateUrl: './signature-section.component.html',
  styleUrls: ['./signature-section.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SignatureSectionComponent implements OnInit, OnDestroy {

  @ViewChild(SignaturePadComponent) signaturePad: SignaturePadComponent;
  @ViewChild("fixedContent") fixedContent: ElementRef;
  @Input() set signature(value: string) {
    this.forceSignature(value);
  }
  @Output() signatureChange = new EventEmitter<string>();

  @Input() askForName = false;
  @Input() signedName = '';
  @Output() signedNameChange = new EventEmitter<string>();

  @Input() enabled = true;
  @Input() name = 'Sign Here';
  @Input() companyName = '';
  @Input() title = '';
  @Input() date = '';
  @Input() signed = false;
  showSignArea = false;

  public signData64 = '';
  public signatureData = '';

  text_Clear = 'Close';

  public signaturePadOptions = {
    'minWidth': 1.0,
    'maxWidth': 3.5,
    'canvasWidth': 500,
    'canvasHeight': 250,
  };


  constructor() {

  }

  ngOnInit() {
    // Try to find the app root element, fallback to body if not found
    const appRoot = document.querySelector("app-root") || document.body;
    if (this.fixedContent && this.fixedContent.nativeElement) {
      appRoot.appendChild(this.fixedContent.nativeElement);
    }

    if (this.signData64) {
      this.complete();
    }
  }

  ngOnDestroy() {
    if (this.fixedContent && this.fixedContent.nativeElement) {
      this.fixedContent.nativeElement.remove();
    }
  }

  signatureComplete() {
    this.signData64 = this.signaturePad.toDataURL();
    this.signed = true;
    this.text_Clear = "Clear";
  }

  forceSignature(imageData: string) {
    if (imageData != null && imageData.includes('http')) {
      // For now, just set the data directly. In a real implementation, you might want to fetch the image
      this.signData64 = imageData;
      this.signed = true;
      this.text_Clear = 'Clear';
    } else {
      this.signData64 = imageData;
      this.signed = true;
      this.text_Clear = 'Clear';
    }
  }

  click_SignEdit() {
    this.showSignArea = true;
  }

  click_SignComplete() {
    this.complete();
  }

  click_Clear() {
    if (this.signed) {
      this.clear();
    } else {
      this.showSignArea = false;

      if (!this.signatureData.includes('http')) {
        this.signatureChange.emit(this.signatureData);
      }
    }
  }

  clear() {
    this.signed = false;
    this.signaturePad.clear();
    this.signatureData = "";
    this.text_Clear = "Close";
  }

  onSignedNameChange() {
    if (this.signedName) {
      console.log(this.signedName);
      this.signedNameChange.emit(this.signedName);
    }
  }

  complete() {
    this.showSignArea = false;
    this.signatureData = this.signData64;

    this.text_Clear = "Clear";

    if (!this.signatureData.includes('http')) {
      this.signatureChange.emit(this.signatureData);
    }
  }

}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/shared/components/signature-section/signature-section.component.ts